/* src/components/sticky-header/sticky-header.component.scss */
:root {
  --vwui--zindex--menu: 99999;
}
:root body.has-sticky-header {
  padding-top: 5rem;
}
app-sticky-header {
  display: block;
  position: fixed;
  z-index: 9999;
  background: #fff;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 0 3rem 0 rgba(0, 0, 0, 0.1);
  height: 5rem;
}
.sticky-header {
  position: relative;
  z-index: 1;
  height: inherit;
}
.sticky-header__slot {
  z-index: 2;
  padding: 0 2rem;
  min-width: 25rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  backface-visibility: hidden;
}
.sticky-header__slot--left,
.sticky-header__slot--right {
  z-index: 1;
  transform: translateY(-50%);
  min-width: auto;
}
.sticky-header__slot--left {
  left: 0;
}
.sticky-header__slot--right {
  left: auto;
  right: 0;
}
/*# sourceMappingURL=sticky-header.component-7JIINB4B.css.map */
